import React from 'react'
import { InputBase, InputBaseProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'

export interface SearchInputProps extends Omit<InputBaseProps, 'startAdornment'> {
  /** Overrides the default magnifying-glass SVG — e.g. a glyph like "⌕" for a command-palette look */
  icon?: React.ReactNode
  /** Trailing mono kbd hint, e.g. "⌘K" */
  hint?: React.ReactNode
}

const Wrap = styled('label')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 9,
  width: '100%',
  color: 'var(--ds-ink-subtle)',
  cursor: 'text',
  '&:focus-within': {
    color: 'var(--ds-ink-muted)',
  },
})

const Field = styled(InputBase)({
  fontFamily: 'var(--ds-font)',
  fontSize: 15,
  fontWeight: 400,
  color: 'var(--ds-ink)',
  minWidth: 0,
  flex: 1,
  '& input::placeholder': {
    color: 'var(--ds-ink-subtle)',
    opacity: 1,
  },
})

const Hint = styled('span')({
  marginLeft: 'auto',
  flexShrink: 0,
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 9.5,
  border: '1px solid var(--ds-border)',
  borderRadius: 5,
  padding: '2px 6px',
  background: 'var(--ds-surface)',
})

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { placeholder = 'Search', icon, hint, ...rest },
  ref,
) {
  return (
    <Wrap>
      {icon ?? <SearchIcon sx={{ fontSize: 18 }} htmlColor='currentColor' />}
      <Field inputRef={ref} placeholder={placeholder} {...rest} />
      {hint && <Hint>{hint}</Hint>}
    </Wrap>
  )
})
